import * as Assert from 'assert'
import * as React from 'react'
import { useEffect, useState } from 'react'

import { taskStyles } from '../../styles/TaskStyles'
import { StartedGameDto } from '../../utils/types'
import { TaskInput } from '../atoms/TaskInput'
import { GamePuzzleTemplate } from './GamePuzzleTemplate'

interface Props {
    secondsLeft: number
    puzzleIndex: number
    game: StartedGameDto
    onComplete(): void
    onReset(): void
}

export const GameSimplePuzzleView: React.FC<Props> = ({
    puzzleIndex, game, onComplete, onReset, secondsLeft
}) => {
    const gamePuzzle = game.puzzles[puzzleIndex]
    const puzzle = game.escapeRoom.puzzles[puzzleIndex]

    Assert.ok(puzzle)
    Assert.ok(gamePuzzle)
    Assert.ok(gamePuzzle.puzzleId === puzzle.puzzleId)

    const [answers, setAnswers] = useState<string[]>(() => puzzle.tasks.map(() => ''))
    const [answerStatuses, setAnswerStatuses] = useState<(boolean | undefined)[]>(
        () => puzzle.tasks.map(() => undefined))

    const styles = taskStyles()
    useEffect(() => {
        setAnswers(puzzle.tasks.map(() => ''))
        setAnswerStatuses(puzzle.tasks.map(() => undefined))
    }, [puzzle])

    const setAnswer = (i: number, v: string) => {
        const newAnswers = [...answers]
        newAnswers[i] = v.toString()

        setAnswers(newAnswers)
    }

    return (
        <GamePuzzleTemplate
            puzzleIndex={puzzleIndex}
            game={game}
            onReset={onReset}
            onComplete={onComplete}
            onValidate={setAnswerStatuses}
            answers={answers}
            canValidate
            secondsLeft={secondsLeft}>
            <div className={styles.answersWrapper}>
                {gamePuzzle.tasks.map((t, i) => {
                    return (
                        <TaskInput
                            valid={answerStatuses[i]}
                            key={t.playerIndex}
                            task={t}
                            onChange={(v) => setAnswer(i, v)}
                            value={answers[i]}/>
                    )
                })}
            </div>

        </GamePuzzleTemplate>
    )
}
